import { MiddleActionButtons } from './components/MiddleActionButtons';
import { WarningIcon } from './components/WarningIcon';
import { LogoTimeDate } from '../../components/common/LogoTimeDate';
import { ThreeCardLayout } from '../../components/layouts/ThreeCardLayout';

interface SomethingWrongLockScreenProps {
  onReload: () => void;
  onContactUs: () => void;
}

export const SomethingWrongLockScreen: React.FC<SomethingWrongLockScreenProps> = ({
  onReload,
  onContactUs,
}) => (
  <ThreeCardLayout
    left={<LogoTimeDate />}
    middleProps={{ alignItems: 'flex-end' }}
    middle={<MiddleActionButtons onReload={onReload} onContactUs={onContactUs} />}
    right={<WarningIcon />}
  />
);
